/* import __COLOCATED_TEMPLATE__ from './turck-io.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();